<script setup lang="ts">
  interface Props {
    canAction: boolean;
    isTest?: boolean; // テスト時のみ true にする
  }
  const props = defineProps<Props>();

  interface Emits {
    (event: "files", files: FileList): void;
    (event: "onDrop"): void;
    (event: "onPaste"): void;
  }
  const emit = defineEmits<Emits>();

  const onDrop = (event: any) => {
    if (props.isTest) {
      emit("onDrop");
    }
    isDragging.value = false;

    if (!props.canAction) {
      return;
    }
    if (!event) return;
    if (!event.dataTransfer) return;
    if (event.dataTransfer.files.length === 0) return;

    emit("files", event.dataTransfer.files);
  };
  const onPaste = (event: any) => {
    if (props.isTest) {
      emit("onPaste");
    }
    if (!props.canAction) {
      return;
    }
    if (!event?.clipboardData?.items) return;

    const files = [];
    for (const item of event.clipboardData.items) {
      if (item.kind === "file") {
        files.push(item.getAsFile());
      }
    }
    if (files.length === 0) {
      return;
    }

    emit("files", files as any);
  };

  const isDragging = ref<boolean>(false);
  const isDraggingInner = ref<boolean>(false);
  // 小要素を持つ要素でドロップをする場合の対策
  // ref: https://qiita.com/sounisi5011/items/dc4878d3e8b38101cf0b
  const dragEnter = () => {
    if (!props.canAction) {
      return;
    }
    isDraggingInner.value = true;
  };
  const dragOver = () => {
    if (!props.canAction) {
      return;
    }
    isDraggingInner.value = false;
    isDragging.value = true;
  };
  const dragLeave = () => {
    if (!props.canAction) {
      return;
    }
    if (isDraggingInner.value) {
      isDraggingInner.value = false;
    } else {
      isDragging.value = false;
    }
  };
</script>

<template>
  <div
    @dragenter.prevent="dragEnter"
    @dragover.prevent="dragOver"
    @dragleave.prevent="dragLeave"
    @drop.prevent="onDrop"
    @paste="onPaste"
  >
    <!-- ドラッグ中の表示 -->
    <div v-if="isDragging" class="isDragging">
      <div class="message">ここにファイルをドロップしてください</div>
    </div>

    <!-- デフォルト slot -->
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
  .isDragging {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #9090906e;
    z-index: 1000;
    .message {
      color: white;
      text-align: center;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateY(-50%) translateX(-50%);
    }
  }
</style>
